import Webcam from 'react-webcam';
import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import { useWindowSize } from 'usehooks-ts';
import React from 'react';

const Wrapper = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #000;
  position: relative;
  display: flex;
  overflow: hidden;

  @media (orientation: landscape) {
    margin-top: 0;
    height: 100%;
    aspect-ratio: unset;
    flex-direction: column;
  }
`;

const StyledWebcam = styled(Webcam)`
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;

  min-width: 100%;
  max-height: 100%;
  object-fit: contain;

  @media (orientation: landscape) {
    width: auto;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

type Props = {
  children: React.ReactNode;
};

export const CameraComponent = ({ children }: Props) => {
  const { cameraRef, state } = useCameraViewContext();
  const { width = 0, height = 1 } = useWindowSize();
  const isLandscape = width > height;

  const agent = navigator.userAgent || navigator.vendor;
  const isAndroid = /android/i.test(agent);

  const videoConstraints = isAndroid
    ? {
        facingMode: 'environment',
        aspectRatio: { exact: 3 / 4 },
        height: { min: isLandscape ? 480 : 640 },
        width: { min: isLandscape ? 640 : 480 }
      }
    : {
        facingMode: 'environment',
        width: isLandscape ? 4032 : 1440,
        height: isLandscape ? 3024 : 1920,
        aspectRatio: 3 / 4
      };

  return (
    <Wrapper id="camera-wrapper" style={{ display: state !== 'taking_photo' ? 'none' : 'flex' }}>
      <StyledWebcam
        audio={true}
        muted
        ref={cameraRef}
        id="camera"
        onUserMediaError={e => {
          alert(e);
        }}
        screenshotQuality={1}
        screenshotFormat={'image/jpeg'}
        hidden={state !== 'taking_photo'}
        videoConstraints={videoConstraints}
        playsInline
        autoPlay
      />
      {children}
    </Wrapper>
  );
};
